var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 8.25C4.3 7.12283 4.76357 6.04183 5.58873 5.2448C6.41389 4.44777 7.53305 4 8.7 4C9.86695 4 10.9861 4.44777 11.8113 5.2448C12.6364 6.04183 13.1 7.12283 13.1 8.25C13.1 9.37717 12.6364 10.4582 11.8113 11.2552C10.9861 12.0522 9.86695 12.5 8.7 12.5C7.53305 12.5 6.41389 12.0522 5.58873 11.2552C4.76357 10.4582 4.3 9.37717 4.3 8.25ZM1 20.0139C1 16.7434 3.74313 14.0938 7.12906 14.0938H10.2709C13.6569 14.0938 16.4 16.7434 16.4 20.0139C16.4 20.5584 15.9428 21 15.3791 21H2.02094C1.45719 21 1 20.5584 1 20.0139ZM21.9447 21H17.2044C17.39 20.6879 17.5 20.326 17.5 19.9375V19.6719C17.5 17.6564 16.5684 15.8469 15.1006 14.6316C15.1831 14.6283 15.2622 14.625 15.3447 14.625H17.4553C20.5181 14.625 23 17.0223 23 19.9807C23 20.5451 22.5256 21 21.9447 21ZM15.85 12.5C14.7844 12.5 13.8219 12.0816 13.1241 11.4076C13.8013 10.5244 14.2 9.43203 14.2 8.25C14.2 7.36016 13.9731 6.52012 13.5709 5.78301C14.2103 5.33145 14.9975 5.0625 15.85 5.0625C17.9778 5.0625 19.7 6.72598 19.7 8.78125C19.7 10.8365 17.9778 12.5 15.85 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounticon);
export default __webpack_public_path__ + "static/media/account.icon.4d33903e03fbb919716ab70379399139.svg";
export { ForwardRef as ReactComponent };